import { put, retry } from "redux-saga/effects";
import API from "@Api";
import { Types } from "../actionTypes";

export function* getProgram(url) {
  try {
    // re-try program lookup call 4 times, every 500 milliseconds
    // only retries if initial call fails.
    const data = yield retry(4, 500, API.program.getProgram, url);

    yield put({ type: Types.FETCHING_PROGRAM_SUCCESS, data });
  } catch (error) {
    yield put({ type: Types.FETCHING_PROGRAM_FAILURE, error });
  }
}
